<h3 class="mat-typography">
  {{'ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_ORDER?' | translate}}
</h3>

<div mat-action-row align="end">
  <button mat-stroked-button mat-dialog-close="false">{{ 'NO' | translate }}</button>
  <button mat-stroked-button mat-dialog-close="cancel" color="warn">{{ 'YES' | translate }}</button>
</div>